import { Helmet } from "react-helmet-async";
import { CANONICAL_HOST } from "../config";

export default function SEO({
  title,
  description,
  path = "/",
  image = "/brand/logo-horizontal-light.svg",
  type = "website",
}) {
  const url = `${CANONICAL_HOST}${path}`;
  const fullTitle = title
    ? `${title} · ClientDesk VA`
    : "ClientDesk VA — The Business Workspace Built for Virtual Assistants";
  const desc =
    description ||
    "Manage clients, bookings, tasks, forms, documents, contracts, invoices and calendars in one organized workspace built for virtual assistants and independent service professionals.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="ClientDesk VA" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image.startsWith("http") ? image : `${CANONICAL_HOST}${image}`} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image.startsWith("http") ? image : `${CANONICAL_HOST}${image}`} />
    </Helmet>
  );
}
